import React from "react";

/**
 * Settings tab — placeholder until global studio settings are designed.
 */
export default function SettingsTab() {
  return (
    <section data-testid="admin-settings-tab">
      <h2 className="font-display text-charcoal text-3xl">Settings</h2>
      <span className="block bg-brass mt-4" style={{ width: 60, height: 1 }} />
      <p className="italic-quote text-charcoal/65 mt-8 text-lg">
        Coming soon — global settings.
      </p>
    </section>
  );
}
